export const normalizePostMediaPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return payload;
  if (payload instanceof FormData) return payload;

  const normalizeUrlArray = (segments) => {
    if (!Array.isArray(segments)) return segments;
    const joined = segments.map((seg) => String(seg).trim()).join('/');
    const collapsed = joined.replace(/([^:]\/)\/+/g, '$1');
    return collapsed.replace(/\/+$/, '');
  };

  let changed = false;
  const next = Array.isArray(payload) ? payload : { ...payload };

  if (Array.isArray(payload.img)) {
    next.img = normalizeUrlArray(payload.img);
    changed = true;
  }

  if (Array.isArray(payload.media)) {
    let mediaChanged = false;
    const normalizedMedia = payload.media.map((item) => {
      if (!item || typeof item !== 'object' || Array.isArray(item)) return item;
      if (Array.isArray(item.url)) {
        mediaChanged = true;
        return { ...item, url: normalizeUrlArray(item.url) };
      }
      return item;
    });
    if (mediaChanged) {
      next.media = normalizedMedia;
      changed = true;
    }
  }

  return changed ? next : payload;
};
